/**
 * A panel on the Marketing tab for a feature that is planned but not built.
 * Same hatch and "Coming soon" pill as a reserved tab.
 *
 * Differs from the design: this replaces the design's NBReservedPanel, whose
 * source was not in the bundle, and it names no tracker in its text.
 */
import { ComingSoonCard } from './ComingSoonCard';

export interface ReservedPanelProps {
  title: string;
  note: string;
}

export function ReservedPanel({ title, note }: ReservedPanelProps) {
  return <ComingSoonCard title={title}>{note}</ComingSoonCard>;
}
